import { render, staticRenderFns } from "./BlockComponentSelector.vue?vue&type=template&id=dcdde73a&"
import script from "./BlockComponentSelector.vue?vue&type=script&lang=js&"
export * from "./BlockComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcdde73a')) {
      api.createRecord('dcdde73a', component.options)
    } else {
      api.reload('dcdde73a', component.options)
    }
    module.hot.accept("./BlockComponentSelector.vue?vue&type=template&id=dcdde73a&", function () {
      api.rerender('dcdde73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/BlockComponentSelector.vue"
export default component.exports